import { IssueTags } from "../components/IssueTags";

/**
 * Fulfillment cell for the sale-invoice list.
 *
 * @param {{
 *   order: Object,
 *   columnHeaderWidth: Object,
 *   cellKey: string
 * }} props
 * @return {*}
 */
export function saleInvoiceFulfillmentListCell({ order, columnHeaderWidth, cellKey }) {
  const fulfillmentWidth =
    columnHeaderWidth.fulfillment ||
    columnHeaderWidth["fulfillment status"] ||
    columnHeaderWidth.issues ||
    140;
  const { has_open_issues, open_issue_tags } = order || {};
  return (
    <td key={cellKey}>
      {has_open_issues || open_issue_tags?.length ? (
        <IssueTags tags={open_issue_tags} invoiceId={order.id} width={fulfillmentWidth} />
      ) : null}
    </td>
  );
}
